var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { BasicDialog } from '../../../../Dialog';
import { useTranslation } from 'react-i18next';
import { KEYS } from '../../../../../i18n';
import { BaseOrderQuoteCreationForm } from './BaseOrderQuoteCreationForm';
import { theme } from '../../../../../theme';
import EditIcon from '@material-ui/icons/Edit';
import OrderRouteMenuItem from '../../OrderRoutesMenuItem';
import { inject } from 'mobx-react';
import BaseTooltip from '../../../../BaseTooltip';
import { TradeIcon } from '../../../../icons';
import { useIconStyles } from '../../../../../styles';
import BaseIconButton from '../../../../BaseIconButton';
export var OrderQuoteEditModal = inject('store')(function (_a) {
    var currentCompany = _a.store.accountStore.currentCompany, props = __rest(_a, ["store"]);
    var classes = useIconStyles();
    var langOfferForm = useTranslation(KEYS.OFFER_FORM);
    var quoteEditForm = React.useRef(null);
    var onEdit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, quoteEditForm.current.submitForm()];
                case 1:
                    if (!(_a.sent()))
                        throw 'Edit quote form is invalid';
                    return [2 /*return*/];
            }
        });
    }); };
    var isOwn = currentCompany._id === props.defaultValue.createdBy.company._id;
    var title = (isOwn
        ? langOfferForm.t('offer_form_edit_btn')
        : langOfferForm.t('offer_form_edit_btn_new_price'));
    var isTrading = !isOwn;
    return (React.createElement(BasicDialog, { onOk: onEdit, dialogProps: isTrading ? {} : { fullWidth: true, maxWidth: 'md' }, withoutWrapper: true, title: title, actionInit: props.actionInit ||
            (function (handleClickOpen) {
                var _a;
                var icon = (React.createElement(BaseTooltip, { title: title },
                    React.createElement(BaseIconButton, { color: 'primary', onClick: handleClickOpen, style: { padding: theme.spacing(0) }, className: clsx((_a = {}, _a[classes.iconDisabled] = props.disabled, _a)), disabled: props.disabled }, !isTrading ? React.createElement(EditIcon, null) : React.createElement(TradeIcon, { style: { width: 24, height: 24 } }))));
                return props.label ? React.createElement(OrderRouteMenuItem, __assign({}, { icon: icon, label: title, handleClickOpen: handleClickOpen })) : icon;
            }), body: React.createElement(BaseOrderQuoteCreationForm, __assign({}, props, { isOwn: isOwn, isTrading: isTrading, ref: quoteEditForm, editRef: quoteEditForm, v3: true })) }));
});
